import { ArrayField, ReferenceField, TextField, WithListContext } from "react-admin";

import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { Grid, useMediaQuery } from "@mui/material";
import { SectionTitle } from "features/SectionTitle";

const ExamsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle
          title="Изпити"
          paddingY={0}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <ArrayField
          source="exams"
          label={""}
        >
          <WithListContext
            render={({ data }) =>
              data.map((exam, index) => {
                return (
                  <Grid
                    item
                    xs={12}
                    key={index}
                  >
                    <ReferenceField
                      record={{ examId: exam?.examId }}
                      source="examId"
                      reference={administrationRequests.getExamsSelect()}
                    >
                      <TextField
                        source="name"
                        color={"#4E2683"}
                        sx={{ fontWeight: "bold", fontSize: "14px" }}
                      />
                    </ReferenceField>
                  </Grid>
                );
              })
            }
          />
        </ArrayField>
      </Grid>
    </Grid>
  );
};
export default ExamsSection;
